<companies-card-list

  [navigateUrl]="navigateUrlPath"
  [companyIdDependency]="companyIdDependency"
  [companyNameDependency]="companyNameDependency"
  [configDependencies]="configDependencies"
  [filterOptions]="filterOptions"
  (filterData)="prepareFiltredData($event)"
  (clickProject)="clickProject($event)"
  (clickCompany)="clickCompany($event)"
 
></companies-card-list>
